module.exports = __webpack_public_path__ + "img/poliglotk2.4e66299d.jpg";